import Rule from "../../../../common/rule";
import DriveEndType from "../../../enums/drive-end-type";
import FootballState from "../../../state/football-state";
import { isRouge } from "../../../utils/context-utils";

export default class Rouge extends Rule {
    // eslint-disable-next-line no-unused-vars
    applicable(
        gameContext,
        ruleContext,
        eventConfiguration,
        { play, fragment }
    ) {
        return (
            fragment.associatedState === FootballState.Rouge &&
            isRouge(play, fragment, gameContext)
        );
    }

    // eslint-disable-next-line no-unused-vars
    async apply(
        gameContext,
        ruleContext,
        eventConfiguration,
        { play, fragment }
    ) {
        const { kickedBy, puntedBy } =
            play.getPreceedingFragment(fragment, [
                FootballState.Kick,
                FootballState.Punt,
                FootballState.CflKick
            ]) || {};

        const { homeTeamId, awayTeamId, gameConfig } = gameContext;
        const { fieldLength } = gameConfig.general;
        const { rougeYardline } = gameConfig.spots;
        const { rougePoints } = gameConfig.scoring;
        const kickingTeamId = (kickedBy || puntedBy).teamId;
        const receivingTeamId =
            kickingTeamId === homeTeamId ? awayTeamId : homeTeamId;

        gameContext.setPossessionForTeamId(receivingTeamId);
        gameContext.setFieldPosition(
            receivingTeamId === homeTeamId
                ? rougeYardline
                : fieldLength - rougeYardline
        );
        gameContext.increaseTeamScore(kickingTeamId, rougePoints);
        ruleContext.playPoints = rougePoints;
        ruleContext.setAwardFirstDown(true);
        gameContext.setDriveContext({
            ...gameContext.getDriveContext(),
            previousDriveEndType: DriveEndType.Rouge
        });
    }
}
